import { ArrowBack } from "@mui/icons-material";
import { Box, Button, FormControl, MenuItem } from "@mui/material";
import Breadcrumbs from "components/common/Breadcrumbs";
import { AppSelect, InputLabel } from "components/common/Input";
import useClients from "hooks/useClients";
import { useNavigate, useParams } from "react-router-dom";
import { EarningsDonationTransactionGroupForm } from "./TransactionGroupForms/EarningsDonationTransactionGroupForm";
import { RevivnDonationMatchTransactionGroupForm } from "./TransactionGroupForms/RevivnDonationMatchTransactionGroupForm";
import { EarningsWithdrawalTransactionGroupForm } from "./TransactionGroupForms/EarningsWithdrawalTransactionGroupForm";
import { EarningsCreditTransactionGroupForm } from "./TransactionGroupForms/EarningsCreditTransactionGroupForm";
import { DonationCreditTransactionGroupForm } from "./TransactionGroupForms/DonationCreditTransactionGroupForm";
import { LaptopRetrievalOrderTransactionGroupForm } from "./TransactionGroupForms/LaptopRetrievalOrderTransactionGroupForm";
import { PickupFeesTransactionGroupForm } from "./TransactionGroupForms/PickupFeesTransactionGroupForm";
import { LaptopRetrievalCancellationTransactionGroupForm } from "./TransactionGroupForms/LaptopRetrievalCancellationTransactionGroupForm";
import { PartnerVendorPaymentTransactionGroupForm } from "./TransactionGroupForms/PartnerVendorPaymentTransactionGroupForm";
import { EarningsDebitTransactionGroupForm } from "./TransactionGroupForms/EarningsDebitTransactionGroupForm";
import { ClaimedInsuranceTransactionGroupForm } from "./TransactionGroupForms/ClaimedInsuranceTransactionGroupForm";

const transactionGroupTypes = [
  "Earnings Donation",
  "Earnings Credit",
  "Earnings Debit",
  "Donation Credit",
  "Revivn Donation Match",
  "Laptop Retrieval Order",
  "Laptop Retrieval Group Order",
  "Laptop Retrieval Cancellation",
  "Revivn Pro Software",
  "Earnings Withdrawal",
  "Pickup Fees",
  "Claimed Insurance",
  "Partner Vendor Payment",
];

export function TransactionGroupsEdit() {
  const { client } = useClients();
  const navigate = useNavigate();
  const { uuid, transactionType } = useParams();

  return (
    <Box>
      <Breadcrumbs
        data={[
          { label: "Finance", to: "/finance/pickups" },
          { label: "Clients", to: "/finance/clients" },
          { label: client ? client?.name : "", to: `/finance/clients/${client?.uuid}` },
          { label: "Edit Transaction" },
        ]}
      ></Breadcrumbs>
      <Box mt={4}>
        <Button
          size="small"
          variant="text"
          startIcon={<ArrowBack />}
          onClick={() => navigate(`/finance/clients/${uuid}/transaction_groups`)}
        >
          back to transactions
        </Button>
      </Box>
      <Box mt={4}></Box>
      <Box
        sx={{
          p: 4,
          mb: 4,
          background: "white",
          borderRadius: 1,
          border: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <FormControl variant="standard" fullWidth>
          <InputLabel shrink htmlFor="name">
            Select type of transaction
          </InputLabel>
          <AppSelect value={transactionType} disabled id="name">
            {transactionGroupTypes.map((transactionGroup) => (
              <MenuItem value={transactionGroup.split(" ").join("")} key={transactionGroup}>
                {transactionGroup}
              </MenuItem>
            ))}
          </AppSelect>
        </FormControl>
      </Box>
      <Box sx={{ background: "white" }}>
        {transactionType === "EarningsDonation" && <EarningsDonationTransactionGroupForm />}
        {transactionType === "EarningsCredit" && <EarningsCreditTransactionGroupForm />}
        {transactionType === "EarningsDebit" && <EarningsDebitTransactionGroupForm />}
        {transactionType === "DonationCredit" && <DonationCreditTransactionGroupForm />}
        {transactionType === "LaptopRetrievalOrder" && <LaptopRetrievalOrderTransactionGroupForm />}
        {transactionType === "LaptopRetrievalCancellation" && <LaptopRetrievalCancellationTransactionGroupForm />}
        {transactionType === "RevivnDonationMatch" && <RevivnDonationMatchTransactionGroupForm />}
        {transactionType === "EarningsWithdrawal" && <EarningsWithdrawalTransactionGroupForm />}
        {transactionType === "PickupFees" && <PickupFeesTransactionGroupForm />}
        {transactionType === "ClaimedInsurance" && <ClaimedInsuranceTransactionGroupForm />}
        {transactionType === "PartnerVendorPayment" && <PartnerVendorPaymentTransactionGroupForm />}
      </Box>
    </Box>
  );
}
